module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-Italic.d31c2f44.ttf";